import { Alert, Box, Button, CircularProgress, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { gateway } from "../../../gateway";

const getReturnPath = () => {
  const path = sessionStorage.getItem("stripeOAuthReturnPath") || "/business/apps-center";
  return path.startsWith("/") && !path.startsWith("//") ? path : "/business/apps-center";
};

export const StripeOAuthCallback = () => {
  const started = useRef(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (started.current) return;
    started.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");
    const denied = params.get("error");
    window.history.replaceState(null, "", window.location.pathname);

    if (denied || !code || !state) {
      setError(denied === "access_denied" ? "Stripe account connection was cancelled." : "Stripe did not return a valid authorization.");
      return;
    }

    gateway.post("/stripe/oauth/complete", { code, state })
      .then(() => {
        const returnPath = getReturnPath();
        sessionStorage.removeItem("stripeOAuthReturnPath");
        window.location.replace(returnPath);
      })
      .catch((requestError: any) => {
        setError(requestError.response?.data?.message || "Could not connect your Stripe account. Please try again.");
      });
  }, []);

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", alignItems: "center", justifyContent: "center", p: 3 }}>
      <Box sx={{ maxWidth: 480, textAlign: "center" }}>
        <Typography variant="h5" sx={{ mb: 2 }}>Connecting your Stripe account</Typography>
        {error ? (
          <>
            <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
            <Button href={getReturnPath()}>Return to FlowNect</Button>
          </>
        ) : <CircularProgress />}
      </Box>
    </Box>
  );
};
